import { getPrivateApi } from "../lib/axiosConfig";
import { GasOrder } from "../types/gasOrder.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/cielo-transactions-pix/gas/hanging";

export const getPendingPayments = async (): Promise<GasOrder[]> => {
  try {
    const { data } = await api.get<GasOrder[]>(endpoint);
    return data;
  } catch (error: any) {
    const errMsg = "Erro ao buscar pagamentos pendentes";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error?.response?.status ?? 500);
  }
};

export const processManualPayment = async (orderId: string): Promise<any> => {
  try {
    const { data } = await api.post(`/cielo-transactions-pix/manual/${orderId}`);
    return data;
  } catch (error: any) {
    const errMsg = "Erro ao processar pagamento manual";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error?.response?.status ?? 500);
  }
};
